var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M7.488 7.825H2.667V5.982a2.416 2.416 0 0 1 2.41-2.41 2.416 2.416 0 0 1 2.411 2.41v1.843Z",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M8.49 20.939h11.83c.558 0 1.014-.456 1.014-1.013V5.982a2.416 2.416 0 0 0-2.41-2.41H5.077a2.416 2.416 0 0 0-2.411 2.41v1.843h4.821v12.111a.999.999 0 0 0 1.003 1.003ZM9.625 9.689h9.53M9.625 12.809h9.53M9.625 15.938h9.53",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperScroll);
export default __webpack_public_path__ + "static/media/paper-scroll.49ba1970.svg";
export { ForwardRef as ReactComponent };